import * as React from "react";
const SvgHeartOutlineWhite = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} fill="none" {...props}>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M20.499 12.947c1.009-1.705 2.87-2.833 4.997-2.742 3.523.151 5.81 3.609 5.205 6.995-.463 2.585-2.245 4.635-4.117 6.546q-.524.533-1.053 1.06c-1.595 1.592-3.181 3.176-4.351 5.071a.8.8 0 0 1-1.362 0c-1.17-1.895-2.756-3.48-4.35-5.071q-.53-.527-1.054-1.06c-1.872-1.911-3.654-3.961-4.117-6.546M20.5 12.947c-1.01-1.705-2.871-2.833-4.997-2.742-3.523.151-5.81 3.609-5.205 6.995m15.13-5.396c-1.997-.086-3.708 1.363-4.062 3.333a.8.8 0 0 1-.788.658h-.157a.8.8 0 0 1-.787-.658c-.354-1.97-2.066-3.42-4.062-3.333l-.035-.8.035.8c-2.395.102-4.164 2.516-3.699 5.114.367 2.049 1.802 3.785 3.685 5.708.32.328.655.66.995 1 1.331 1.328 2.766 2.759 3.947 4.395 1.18-1.636 2.616-3.067 3.947-4.395q.512-.509.995-1c1.883-1.923 3.318-3.659 3.685-5.708l.787.141-.788-.14c.465-2.6-1.303-5.013-3.698-5.115"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgHeartOutlineWhite;
